import { useMemo } from 'react';

import { formatLargeNumber } from 'lib/helpers/utility';
import { useTableContext } from 'lib/context/TableContext/TableContext';

import Button from 'components/shared/Button/Button';
import Popover from 'components/shared/Popovers/Popover/Popover';
import Typography from 'components/shared/Typography/Typography';

import { PAGE_SIZE_OPTIONS } from '../../lib/constants';

const RowsPerPageOptions = ({ onChange }) => {
  const { limit = 25, pagination } = useTableContext();

  const options = useMemo(
    () => PAGE_SIZE_OPTIONS.map((option) => ({ ...option, onClick: () => onChange(option.value) })),
    [onChange]
  );

  if (!pagination) return null;

  return (
    <div className="flex items-center justify-between gap-2 py-1">
      <Typography icon="list-unordered-mono" iconColor="neutral-700" variant="label" size="medium">
        Rows per page
      </Typography>
      <Popover
        position="left"
        panelClassName="p-0 border border-neutral-100 shadow-spread-medium rounded border-solid gap-y-1"
        optionGroupLabelClassName="h-10 px-4 py-2"
        options={options}
        customButtonTrigger={({ open }) => (
          <Button
            size="xs"
            text={formatLargeNumber(limit)}
            variant="tertiary"
            iconColor="neutral"
            iconRight={open ? 'chevron-up-linear' : 'chevron-down-linear'}
            iconShade={700}
            className={open && 'whitespace-nowrap bg-neutral-100'}
          />
        )}
      />
    </div>
  );
};

export default RowsPerPageOptions;
